import React from "react";

const Header = () => (
  <a className="mx-2" href="https://soc.keture.com/">
    <span className="text-3xl font-black mx-2 text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-red-600">Keture</span>
    <span className="text-xl tracking-wide mx-1">School of Coding</span>
    <hr className="h-[.05em] mb-8 mt-4 mx-4 bg-slate-200 border-0 dark:bg-slate-700" />
  </a>
);

export default Header;
